import { useId, useState } from "react";
import { formatGbp, parseMoney, placementFee, providerCut } from "../lib/fees";

/**
 * The sign-up page's signature moment: a sentence you edit. It shows what a percentage-based
 * "recruiter-in-a-box" provider takes from one placement. It makes no claim about our price.
 */
export function FeeCalculator() {
  const id = useId();
  const [salary, setSalary] = useState("100,000");
  const [feePct, setFeePct] = useState("20");
  const [cutPct, setCutPct] = useState("20");

  const fee = placementFee(parseMoney(salary), Number(feePct));
  const cut = providerCut(fee, Number(cutPct));

  return (
    <div className="calc">
      <p className="calc-sentence">
        Place a <span className="sr-only">candidate on a salary of</span>£
        <input
          id={`${id}-salary`}
          className="wide"
          inputMode="numeric"
          aria-label="Candidate salary in pounds"
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
        />{" "}
        candidate at a{" "}
        <input
          id={`${id}-fee`}
          inputMode="decimal"
          aria-label="Your placement fee percentage"
          value={feePct}
          onChange={(e) => setFeePct(e.target.value)}
        />
        % fee, with a provider taking{" "}
        <input
          id={`${id}-cut`}
          inputMode="decimal"
          aria-label="Provider's share of your fee, percent"
          value={cutPct}
          onChange={(e) => setCutPct(e.target.value)}
        />
        % of it.
      </p>
      <div className="calc-result" aria-live="polite">
        <p className="calc-keep">
          Keep <span className="figures">{formatGbp(fee)}</span>.
        </p>
        <p className="calc-lost">
          Not <s className="figures">{formatGbp(fee - cut)}</s> after handing <span className="figures">{formatGbp(cut)}</span>{" "}
          to a provider. Every placement.
        </p>
      </div>
    </div>
  );
}
